module.exports = __webpack_public_path__ + "img/coach-1.c802fce3.jpg";